<!-- Tab "MCP-Connectoren" of /agent-setup — the host owns header and card. -->
<!-- The responsibility in one sentence, where a connector is created. -->
<p class="scope-note">{{ "pages.mcp.responsibilityNote" | translate }}</p>
<app-table
  rowIdKey="id"
  [nbSpinner]="isLoading"
  [title]="''"
  [columns]="columns"
  [data]="rows"
  [rowActions]="rowActions"
  [globalActions]="globalActions"
  [maxVisibleItems]="25"
  (event)="onTableEvent($event)"
></app-table>
